import { configureStore } from "@reduxjs/toolkit";
import WorkHubAppSlice from './reducer'

export const Store = configureStore({
  reducer: {
    WorkHubAppSlice,
  },
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       serializableCheck: false,
//     }),
});